import { TReportTaskItem } from "@/types";

/** Lines the bulk editor takes; a paste past it is cut, with a warning. */
export const MAX_BULK_TASK_LINES = 500;

// A list marker pasted along with the tasks: "- ", "* ", "• ", "– ",
// "1. ", "2) ". Only with the space after it, so "-1 day" stays whole.
const BULLET = /^\s*(?:[-*•–—]|\d+[.)])\s+/;

/** One task per line. A line break inside a task would split it in two on the way back, so it becomes a space. */
export const tasksToText = (tasks: TReportTaskItem[]): string =>
	tasks.map((task) => task.text.replace(/\s*[\r\n]+\s*/g, " ")).join("\n");

/** The lines of the bulk editor that make tasks: bullets stripped, trimmed, blanks dropped. */
export const textToLines = (text: string): string[] =>
	text
		.split(/\r?\n/)
		.map((line) => line.replace(BULLET, "").trim())
		.filter(Boolean);

/**
 * The bulk editor's text back as tasks. A line identical to an existing
 * task keeps that task's id (duplicates matched in order), so only what
 * was actually typed or changed becomes new; the rest is the same list,
 * possibly reordered.
 */
export const textToTasks = (
	text: string,
	previous: TReportTaskItem[]
): TReportTaskItem[] => {
	const idsByText = new Map<string, string[]>();
	for (const task of previous) {
		const ids = idsByText.get(task.text) ?? [];
		ids.push(task.id);
		idsByText.set(task.text, ids);
	}

	return textToLines(text)
		.slice(0, MAX_BULK_TASK_LINES)
		.map((line) => ({
			id: idsByText.get(line)?.shift() ?? crypto.randomUUID(),
			text: line,
		}));
};
